// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d52944a2","453":"9dd6ee68","455":"f1ba2843","762":"3c8dc92a","977":"404962a0"}[chunkId] + ".chunk.js";
};